module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("29dXI"))).then(() => parcelRequire('3a9aZ'));